<script lang="ts">
  import {onMount} from 'svelte'
  import type {Poem, User} from './types'
  import api from './api/api'
  import {modal} from './stores/modal'
  import Register from './authentication/Register.svelte'
  import {Link, navigate} from 'svelte5-router'
  import {user} from './stores/user'
  import {t} from './i18n'
  import SmallPoem from './poems/SmallPoem.svelte'
  import UserCardSmall from './users/UserCardSmall.svelte'
  import ClassicSmallPoem from './poems/ClassicSmallPoem.svelte'
  import LoadMore from './shared/LoadMore.svelte'

  let tradingPoems: Poem[] = []
  let recommendedPoems: Poem[] = []
  let monthUsers: User[] = []
  let classicsPoems: Poem[] = []

  onMount(load)

  async function load() {
    [tradingPoems, monthUsers, classicsPoems] = await Promise.all([
      api.get<Poem[]>('/poems/trading?per=3'),
      api.get<User[]>('/users?per=8'),
      api.get<Poem[]>('/poems/trading_classics?per=3')
    ])
  }

  function openRegister(e: Event) {
    e.preventDefault()
    modal.show(Register)
  }

  function addPoem() {
    navigate('/poems/new')
  }
</script>

<div class="row">
  <!-- Sign-up Section -->
  {#if !$user}
    <div class="sign-up-present">
      <h1>{t.home.tagline}</h1>
      <div>
        <p>{t.home.description}</p>
        <div>
          <button class="sign-up-button" onclick={openRegister}>{t.home.sign_up_free}</button>
        </div>
      </div>
    </div>
  {/if}

  <!-- Trading Poems Section -->
  <div class="grid-section">
    <div class="heading">
      <h2>
        {t.home.trading_poems.title}
        <Link class="small-notice" to="/help"><span>{t.home.how_to_get}</span></Link>
      </h2>
    </div>

    <div class="grid three">
      {#each tradingPoems as poem}
        <div class="grid__item">
          <SmallPoem {poem}/>
        </div>
      {/each}
    </div>
  </div>

  <!-- Month Authors Section -->
  <div class="grid-section">
    <div class="heading">
      <h2>
        {t.home.month_authors.title}
        <Link class="see-all" to="/authors">{t.home.all_authors}</Link>
      </h2>
    </div>

    <div class="grid four">
      {#each monthUsers as user}
        <div class="grid__item">
          <UserCardSmall {user}/>
        </div>
      {/each}
    </div>
  </div>

  <!-- Month Classics Section -->
  <div class="grid-section">
    <div class="heading">
      <h2>
        {t.home.month_classics.title}
        <Link class="see-all" to="/poets">{t.home.all_classics}</Link>
      </h2>
    </div>

    <div class="grid three">
      {#each classicsPoems as poem}
        <div class="grid__item">
          <ClassicSmallPoem {poem}/>
        </div>
      {/each}
    </div>
  </div>

  {#if $user}
    <div class="grid-section">
      <div class="heading">
        <h2>{t.home.recommended_poems.title}</h2>
      </div>

      <div class="grid three">
        {#each recommendedPoems as poem}
          <div class="grid__item">
            <SmallPoem {poem}/>
          </div>
        {/each}
      </div>
    </div>

    <LoadMore url="/poems/recommended" bind:items={recommendedPoems}/>
  {/if}
</div>
